module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/es-f753d61a0742c62c70cec6dfdfc06ecc.png";